export default __webpack_public_path__ + "static/media/lock_red.421ac9ce.svg";